import { useTranslation } from 'react-i18next';
import '../../../styles/components/subscriptionPackages/seller/sellerPackages.scss';
import { useState } from 'react';
import SellerPackageItem from './SellerPackageItem';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { tickWithCircleSVG } from '../../../lib/allCustomSVGs';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import isNotEmptyString from '../../../lib/helper-functions/isNotEmptyString';

type Props = {
  taraSubscriptionPackages: any[];
};

const SellerPackages = ({ taraSubscriptionPackages }: Props) => {
  const { t } = useTranslation();
  const [isMonthly, setIsMonthly] = useState<boolean>(true);
  const [isSupportPopupOpen, setIsSupportPopupOpen] = useState<boolean>(false);
  const taraTrialDetails = useSelector(
    (state: RootState) => state.user?.shop?.taraTrialDetails
  ) || { is_trial: false, trial_available_days: undefined };
  const paymentPopupTemporaryMessage = useSelector(
    (state: RootState) => state.UI.paymentPopupTemporaryMessage
  );

  // <-- New: derive role from Redux -->
  const userRole: 'seller' | 'agency' =
    useSelector((state: RootState) => state.user?.profile?.role) === 'agency'
      ? 'agency'
      : 'seller';

  // <-- New: filter packages by role -->
  const packagesByRole = taraSubscriptionPackages.filter(
    (pkg) => pkg.role === userRole
  );

  return (
    <>
      {isSupportPopupOpen ? (
        <div className='sellerPackages--support'>
          <h3>{t('EmailSentSuccessfully')}</h3>
          <CustomSVGs svg={tickWithCircleSVG} />
        </div>
      ) : (
        <div className='sellerPackages'>
          <div className='sellerPackages__titles'>
            <h2>{t('Plans&Prices')}</h2>
            <p>{t('ChoosePlan-subtext')}</p>
          </div>

          {userRole === 'seller' &&
          taraTrialDetails &&
          taraTrialDetails?.is_trial &&
          taraTrialDetails?.trial_available_days &&
          taraTrialDetails?.trial_available_days > 0 &&
          !isNotEmptyString(paymentPopupTemporaryMessage) ? (
            <div className='sellerPackages__banner'>
              <div className='sellerPackages__banner--left'>
                <h3>{t('TaraPackageBannerText1Business')}</h3>
                <p>{t('TaraPackageBannerText2Business')}</p>
                {/* <p>{t('TaraPackageBannerText3')}</p> */}
              </div>
              {/* <div
                onClick={() => {
                  dispatch(setCurrentChat(null));
                  dispatch(setIsBotTyping(false));
                  navigate('/tara');
                  dispatch(setIsPaymentPopupOpen(false));
                }}
                className='sellerPackages__banner--right'
              >
                <span>{t('StartNow')}</span>
              </div> */}
            </div>
          ) : null}

          {userRole === 'agency' ? (
            <div className='sellerPackages__banner'>
              <div className='sellerPackages__banner--left'>
                <h3>{t('TaraPackageBannerText1Agency')}</h3>
                <p>{t('TaraPackageBannerText2Agency')}</p>
              </div>
            </div>
          ) : null}

          {isNotEmptyString(paymentPopupTemporaryMessage) && (
            <div
              className='collapseList__item--top-left-tag collapseList__item--top-left-tag-yellow'
              style={{
                width: 'fit-content',
                marginBottom: '2.5rem',
                fontSize: '1.4rem',
              }}
            >
              {paymentPopupTemporaryMessage}
            </div>
          )}

          {/* {((taraSubscriptionDetails &&
            taraSubscriptionDetails?.currentSubscriptionStatus === 'none') ||
            !taraSubscriptionDetails) &&
            userRole === 'agency' && (
              <div className='sellerPackages__progressBar'>
                <ProgressBarPlus
                  progress={32}
                  totalSpots={100}
                  // spotsRemaining={34}
                  // title='Early Bird Special'
                  availabilityLabel='Capacity'
                  limitText={t('TaraPackageProgressBarText')}
                />
              </div>
            )} */}

          {/* Toggle only for sellers */}
          {userRole === 'seller' && (
            <div className='sellerPackages__selection'>
              <div className='sellerPackages__selection--text'>
                {t('PayMonthly')}
              </div>
              <div className='sellerPackages__selection--toggle'>
                <input
                  className='sellerPackages__selection--toggle-input'
                  type='checkbox'
                  id='mode-toggle'
                  checked={!isMonthly}
                  onChange={() => setIsMonthly((m) => !m)}
                />
                <label
                  className='sellerPackages__selection--toggle-label'
                  htmlFor='mode-toggle'
                />
              </div>
              <div className='sellerPackages__selection--text'>
                {t('PayAnnually')}
              </div>
              <div className='sellerPackages__selection--info'>
                {`10%  ${t('Cheaper')}`}
              </div>
            </div>
          )}

          {/* Render exactly 3 packages filtered by role */}
          <div className='sellerPackages__items'>
            {packagesByRole.map((packageDetails) => (
              <SellerPackageItem
                key={packageDetails.id}
                isMonthly={isMonthly}
                packageDetails={packageDetails}
                setIsSupportPopupOpen={setIsSupportPopupOpen}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default SellerPackages;
